import { render, staticRenderFns } from "./ReportTabMoreRestaurants.vue?vue&type=template&id=1c50dc8b"
import script from "./ReportTabMoreRestaurants.vue?vue&type=script&lang=js"
export * from "./ReportTabMoreRestaurants.vue?vue&type=script&lang=js"
import style0 from "./ReportTabMoreRestaurants.vue?vue&type=style&index=0&id=1c50dc8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports